'use client';

import { useTranslations } from 'next-intl';

const fallbackMessages: Record<string, string> = {
  'error.title': 'Something went wrong',
  'error.desc': 'An unexpected error occurred. Please try again.',
  'error.retry': 'Try Again',
  'error.backHome': 'Back to Home',
  'notFound.title': 'Oops, page not found!',
  'notFound.desc': "The page you requested couldn't be found",
  'notFound.check': 'Please check if your URL is correct',
  'notFound.backHome': 'Back to Home',
  accessDenied: 'Access denied!',
  goToHome: 'Go To Home',
};

const useSafeErrorTranslations = () => {
  try {
    return useTranslations('error');
  } catch (error) {
    return (key: string) => fallbackMessages[key] ?? key;
  }
};

export default useSafeErrorTranslations;
